import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import clientStore from './stores/clientStore';
import subsidiaryStore from './stores/subsidiaryStore';
import userStore from './stores/userStore';
import buildingStore from './stores/buildingStore';
import unitStore from './stores/unitStore';
import expenseStore from './stores/expenseStore';
import projectStore from './stores/projectStore';
import projectCompStore from './stores/projectCompStore';
import projectSiteStore from './stores/projectSiteStore';
import proposalStore from './stores/proposalStore';
import tourStore from './stores/tourStore';
import ksdStore from './stores/ksdStore';
import reatlasOld from './stores/reatlas';
import reatlasV1 from './stores/v1/reatlas';

// Determine which reatlas store to use based on theme
const isV1Theme = document.documentElement.getAttribute('data-theme') === 'v1';
const reatlas = isV1Theme ? reatlasV1 : reatlasOld;
console.log('Loading REatlas store:', isV1Theme ? 'v1' : 'old', '(data-theme:', document.documentElement.getAttribute('data-theme'), ')');
import creSiteIQStore from "./stores/creSiteIQStore";
import compStore from './stores/compStore';
import siteStore from './stores/siteStore';
import documentStore from './stores/documentStore';
import reportStore from './stores/reportStore';
import leaseStore from './stores/leaseStore';
import contactStore from './stores/contactStore';
import commentStore from './stores/commentStore';
import changeLogStore from './stores/changeLogStore';
import planModuleStore from './stores/planModuleStore';
import moduleAccessStore from './stores/moduleAccessStore';
import billingStore from './stores/billingStore';
import taskStore from './stores/taskStore';
import chatStore from './stores/modules/chat';
import listingSearchStore from './stores/listingSearchStore';

const store = new Vuex.Store({
	state: {
	},
	mutations: {
	},
	modules: {
		clients: clientStore,
		subsidiaries: subsidiaryStore,
		users: userStore,
		buildings: buildingStore,
		units: unitStore,
		expenses: expenseStore,
		projects: projectStore,
		projectComps: projectCompStore,
		projectSites: projectSiteStore,
		proposals: proposalStore,
		tours: tourStore,
		ksds: ksdStore,
		reatlas: reatlas,
		creSiteIQ: creSiteIQStore,
		comps: compStore,
		sites: siteStore,
		leases: leaseStore,
		documents: documentStore,
		reports: reportStore,
		contacts: contactStore,
		comments: commentStore,
		changeLog: changeLogStore,
		'plan-modules': planModuleStore,
		moduleAccess: moduleAccessStore,
		billing: billingStore,
		tasks: taskStore,
		chat: chatStore,
		listingSearch: listingSearchStore
	}
})

export default store;
